import React from 'react'
import AnalyzerDemoData from 'Pages/AnalyzersV2/@tour/DemoData'
import { demoPopoverOpen } from './signals'

// Demo shown by the Virtual Tour when no report is loaded: one column per pickup date
const ROWS = [
	{ name: 'alphacars', country: 'GB', prices: [165.20, 172.88, 169.41, 178.55] },
	{ name: 'peakrentals', country: 'GB', prices: [98.45, 102.33, 101.10, 107.22] },
	{ name: 'eurodrive', country: 'GB', prices: [101.30, 105.77, 103.95, 112.60] },
	{ name: 'horizoncars', country: 'GB', prices: [103.88, 106.38, 108.50, 115.20] },
	{ name: 'swiftfleet', country: 'GB', prices: [99.70, 106.98, 104.25, 110.45] },
]

// As the real header draws a date: the weekday over the date
const COLUMNS = [
	{ day: 'Monday', label: '12 May 2025' },
	{ day: 'Wednesday', label: '14 May 2025' },
	{ day: 'Friday', label: '16 May 2025' },
	{ day: 'Monday', label: '19 May 2025' },
]

export default function DorDemoData() {
	return <AnalyzerDemoData
		demoPopoverOpen={demoPopoverOpen}
		columns={COLUMNS}
		rows={ROWS}
		chart={{ title: 'Dates of Rental', type: 'line' }}
		pickup="12 May 2025"
	/>
}
